import { colors } from 'theme/color-palette';
import { makeStyles } from '@material-ui/core/styles';

const { PURPLE, GREY, WHITE } = colors;

const Styles = makeStyles(() => ({
	/* First time UX - Custom dataset */
	card: {
		maxWidth: '400px',
		minWidth: '386px'
	},
	initBox: {
		padding: '16px',
		borderRadius: '8px',
		backgroundColor: '#EBE8F3'
	},
	initHeading: {
		display: 'flex'
	},
	initHeadingText: {
		fontSize: 18,
		fontWeight: 700
	},
	closeIcon: {
		color: GREY,
		marginRight: 0,
		cursor: 'pointer',
		marginLeft: 'auto'
	},
	initContent: {
		fontSize: 14,
		marginTop: 12,
		width: '260px',
		fontWeight: 400
	},
	initFooter: {
		marginTop: 12,
		display: 'flex',
		gap: 8
	},
	initShowBtn: {
		color: WHITE,
		fontSize: 14,
		fontWeight: 700,
		padding: '6px 16px',
		borderRadius: '100px',
		backgroundColor: PURPLE,
		'&:hover': {
			backgroundColor: PURPLE
		}
	},
	learnMoreBtn: {
		fontSize: 14,
		fontWeight: 700,
		'&:hover': {
			backgroundColor: '#EBE8F3'
		}
	},
	openInNewIcon: {
		color: GREY,
		marginLeft: 8,
		width: 12,
		height: 12
	},

	/* Tooltip */
	tooltipContainer: {
		width: '340px',
		borderRadius: '16px',
		backgroundColor: WHITE
	},
	tooltipHeader: {
		display: 'flex',
		padding: '16px 24px',
		alignItems: 'center',
		justifyContent: 'space-between',
		'& p': {
			fontSize: '18px',
			fontWeight: 700
		}
	},
	tooltipCloseIcon: {
		color: GREY,
		cursor: 'pointer',
		marginLeft: '16px'
	},
	tooltipContent: {
		padding: '0 24px 24px'
	},
	tooltipFooter: {
		display: 'flex',
		padding: '8px 24px 16px'
	},
	nextBtn: {
		color: WHITE,
		fontSize: 14,
		fontWeight: 700,
		marginLeft: 'auto',
		padding: '10px 16px',
		borderRadius: '100px',
		alignSelf: 'flex-end',
		backgroundColor: PURPLE,
		'&:hover': {
			backgroundColor: PURPLE
		}
	}
}));

export default Styles;
